import React from "react";
import styled from "styled-components";

const TextStyle = styled.div`
  font-size: 12px;
  color: #475467;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

function SubTitleText({ children, style }) {
  return <TextStyle style={style}>{children}</TextStyle>;
}
export default SubTitleText;
